// constants.js
export const RESOURCE_TYPES = [
  "All Other",
  "Agendas",
  "All",
  "Case Studies",
  "Company Decks & Information",
  "Competitive Battlecards",
  "Customer Testimonials",
  "Demo and Demo Scripts",
  "Domain & Industry",
  "Email Templates",
  "Persona Decks",
  "Plays & Scenarios",
  "Pricing Guides",
  "Products",
  "Product Sheets",
  "ROI Calculators",
  "RevOps",
  "Sales Architecture",
  "Sales Decks",
  "Tools",
  "Training Materials",
  "Video",
  "The Different Manager",
  "The Different Salesperson",
  "Other",
];

// Import and execute function from canonical source
// This maintains backward compatibility while using single source of truth
import { getMentalStatesForUI } from "@/lib/conversation-bot/config/mental-states";
export const mentalStates = getMentalStatesForUI();

export const RESOURCE_SECTIONS = ["know", "say", "show", "do", "training"];

export const fillerWords = [
  "ok",
  "okay",
  "um",
  "uh",
  "like",
  "so",
  "actually",
  "basically",
  "seriously",
  "literally",
  "you know",
  "i mean",
  "anyway",
  "sort of",
  "kind of",
  "really",
  "pretty",
  "just",
  "maybe",
  "perhaps",
  "i guess",
  "you see",
  "well",
  "quite",
  "right",
  "believe me",
  "in a sense",
  "if you will",
  "to tell you the truth",
  "to be honest",
  "in fact",
];

export const RETIRED_VOICE_REPLACEMENTS = {
  FYrAIz05kOZukZeW2HGc: "MzqUf1HbJ8UmQ0wUsx2p",
};

export function resolveVoiceModelId(voiceId) {
  if (typeof voiceId !== "string") return voiceId;

  const normalizedVoiceId = voiceId.trim();
  return RETIRED_VOICE_REPLACEMENTS[normalizedVoiceId] || normalizedVoiceId;
}

export const VOICE_MODELS = {
  alloy: {
    label: "Alloy",
    type: "openai",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  ash: {
    label: "Ash",
    type: "openai",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  ballad: {
    label: "Ballad",
    type: "openai",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  coral: {
    label: "Coral",
    type: "openai",
    gender: "neutral",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  echo: {
    label: "Echo",
    type: "openai",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  fable: {
    label: "Fable",
    type: "openai",
    gender: "neutral",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  nova: {
    label: "Nova",
    type: "openai",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  onyx: {
    label: "Onyx",
    type: "openai",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  sage: {
    label: "Sage",
    type: "openai",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  shimmer: {
    label: "Shimmer",
    type: "openai",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  "aura-asteria-en": {
    label: "Asteria (US Female)",
    type: "deepgram",
    gender: "female",
    languages: ["en"],
  },
  "aura-luna-en": {
    label: "Luna (US Female)",
    type: "deepgram",
    gender: "female",
    languages: ["en"],
  },
  "aura-stella-en": {
    label: "Stella (US Female)",
    type: "deepgram",
    gender: "female",
    languages: ["en"],
  },
  "aura-athena-en": {
    label: "Athena (UK Female)",
    type: "deepgram",
    gender: "female",
    languages: ["en"],
  },
  "aura-hera-en": {
    label: "Hera (US Female)",
    type: "deepgram",
    gender: "female",
    languages: ["en"],
  },
  "aura-orion-en": {
    label: "Orion (US Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-arcas-en": {
    label: "Arcas (US Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-perseus-en": {
    label: "Perseus (US Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-angus-en": {
    label: "Angus (Irish Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-orpheus-en": {
    label: "Orpheus (US Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-helios-en": {
    label: "Helios (UK Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  "aura-zeus-en": {
    label: "Zeus (US Male)",
    type: "deepgram",
    gender: "male",
    languages: ["en"],
  },
  MzqUf1HbJ8UmQ0wUsx2p: {
    label: "Karen",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  jnc8ZkFif5r9EOiUIcXH: {
    label: "Margo",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  eiiwPzAp6oh0CtQDgKFj: {
    label: "George",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  KoQQbl9zjAdLgKZjm8Ol: {
    label: "Paul",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  YXpFCvM1S3JbWEJhoskW: {
    label: "Wyatt",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  L1aJrPa7pLJEyYlh3Ilq: {
    label: "Oliver",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "en",
  },
  // Curated for English dialogue with regional accents. Restrict these voices
  // to English in both persona editors and runtime language selection.
  c3xntgIY160tGkH7rVz2: {
    label: "June (Hong Kong English)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en"],
    nativeLanguage: "en",
  },
  u6a6bRv82Zfi9NzoIqvt: {
    label: "Lia (Japanese English)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en"],
    nativeLanguage: "en",
  },
  Lci8YeL6PAFHJjNKvwXq: {
    label: "Yusuke (Japanese English)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en"],
    nativeLanguage: "en",
  },
  Zjb2Dbq5IbWDKpVOllIo: {
    label: "Hanna (Korean English)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en"],
    nativeLanguage: "en",
  },
  owsLoyJNU4K7ctU6NF7F: {
    label: "Mun (Singaporean English)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en"],
    nativeLanguage: "en",
  },
  "6qpxBH5KUSDb40bij36w": {
    label: "Lilian (Singaporean English)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en"],
    nativeLanguage: "en",
  },
  Z7waMujh537KStREwfTf: {
    label: "Ran (Filipino English)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en"],
    nativeLanguage: "en",
  },
  Eprt7XYIrZKqBpPVgsgK: {
    label: "Ramesh (Indian English)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en"],
    nativeLanguage: "en",
  },
  w7IU2bIH6xHcyfkUUWi3: {
    label: "Santiago",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "es",
  },
  // Native German voices (ElevenLabs, verified against the TTS endpoint with
  // eleven_turbo_v2_5). Chosen for a B2B buyer: professional, standard German
  // rather than regional, and none of the audiobook/meditation/children's
  // character voices the library is mostly made of. A German speaker still has
  // to sign off on which of these sounds like a plausible buyer.
  eHUtR7GEpF8oQODRxCTo: {
    label: "Clara (German)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "de",
  },
  iV1OKYxbmgRtpzJ2q8kx: {
    label: "Nora (German)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "de",
  },
  KtIyhQZ1e9ScxWYGlFy6: {
    label: "Philipp (German)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "de",
  },
  zIaesnEtOU9IimNaWidI: {
    label: "Rene (German)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "de",
  },
  // Native Spanish voices (ElevenLabs). Peninsular rather than Latin American,
  // because the studio driving this sells into Europe. The library also has
  // Mexican, Colombian, Chilean and other regional voices if a studio sells
  // into those markets; accent is a real choice here, not a detail.
  BkOojM1ZhtSAHgsAkMx2: {
    label: "Carolina (Spanish)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "es",
  },
  "3xo8vOwxfBdazUIbWODB": {
    label: "Esther (Spanish)",
    type: "elevenlabs",
    gender: "female",
    languages: ["en", "de", "es"],
    nativeLanguage: "es",
  },
  E3gU1I86D0XjvRrEszPm: {
    label: "Daniel (Spanish)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "es",
  },
  KbHzTDrKkWZhO8WaGUeG: {
    label: "Enrique (Spanish)",
    type: "elevenlabs",
    gender: "male",
    languages: ["en", "de", "es"],
    nativeLanguage: "es",
  },
  // Deepgram Aura-2 native German and Spanish. The aura-*-en entries above are
  // Aura-1 and really are English-only, but the provider itself is not: Aura-2
  // ships per-language voices, verified against /v1/speak. Worth having as well
  // as the ElevenLabs ones because Deepgram is the lower-latency path, which
  // matters most in live voice mode — and because the phone can speak them.
  // VAPI cannot resolve our ElevenLabs voices, so a phone call substitutes the
  // first native voice of the persona's gender that VAPI lists
  // (lib/personas/vapi-voice.js); every language therefore needs one per
  // gender here, and vapi-voice.test.js fails when one is missing. Silvia is
  // the exception — Deepgram speaks her, VAPI's DeepgramVoice enum does not
  // list her — which is why Carina and Diana follow.
  "aura-2-viktoria-de": {
    label: "Viktoria (German, fast)",
    type: "deepgram",
    gender: "female",
    languages: ["de"],
    nativeLanguage: "de",
  },
  "aura-2-julius-de": {
    label: "Julius (German, fast)",
    type: "deepgram",
    gender: "male",
    languages: ["de"],
    nativeLanguage: "de",
  },
  "aura-2-silvia-es": {
    label: "Silvia (Spanish, fast)",
    type: "deepgram",
    gender: "female",
    languages: ["es"],
    nativeLanguage: "es",
  },
  "aura-2-nestor-es": {
    label: "Nestor (Spanish, fast)",
    type: "deepgram",
    gender: "male",
    languages: ["es"],
    nativeLanguage: "es",
  },
  // Peninsular, like the ElevenLabs picks. Verified 2026-09-09 against both
  // Deepgram's catalogue (GET /v1/models: es-ES, feminine) and VAPI's enum.
  "aura-2-carina-es": {
    label: "Carina (Spanish, fast)",
    type: "deepgram",
    gender: "female",
    languages: ["es"],
    nativeLanguage: "es",
  },
  "aura-2-diana-es": {
    label: "Diana (Spanish, fast)",
    type: "deepgram",
    gender: "female",
    languages: ["es"],
    nativeLanguage: "es",
  },
};

export const BADGE_ICONS = {
  STAR: "Star",
  AWARD: "Award",
  TROPHY: "Trophy",
  MEDAL: "Medal",
  CROWN: "Crown",
  ROCKET: "Rocket",
  ZAPS: "Zap",
  FLAME: "Flame",
  HEART: "Heart",
  THUMBS_UP: "ThumbsUp",
  LIGHTBULB: "Lightbulb",
  BRAIN: "Brain",
  TARGET: "Target",
  CHART: "BarChart",
  BOOK: "BookOpen",
  GRADUATION: "GraduationCap",
  BRIEFCASE: "Briefcase",
  HANDSHAKE: "Handshake",
  MICROPHONE: "Mic",
  PRESENTATION: "Presentation",
};

export const BADGE_SHAPES = {
  CIRCLE: "circle",
  SHIELD: "shield",
  DIAMOND: "diamond",
};

export const BADGE_SHAPE_SVG = {
  circle: "M50 0A50 50 0 1 0 50 100A50 50 0 1 0 50 0Z",
  shield:
    "M50 5 C75 5 95 15 95 15 L95 40 C95 65 75 90 50 95 C25 90 5 65 5 40 L5 15 C5 15 25 5 50 5 Z",
  diamond: "M50 0 L100 50 L50 100 L0 50 Z",
};

// Constraints for custom badge logo uploads. Badges render inside a square,
// shape-clipped container everywhere in the app, so a square (1:1) image at a
// reasonable resolution is what looks good. These are enforced client-side
// before upload; the API route also guards type and file size.
export const BADGE_IMAGE = {
  // Recommended export size for a crisp badge at every display scale.
  RECOMMENDED_SIZE: 512,
  // Minimum allowed dimension (px) on each side.
  MIN_SIZE: 128,
  // Allowed deviation from a perfect 1:1 square (width/height). 0.05 = ±5%.
  ASPECT_TOLERANCE: 0.05,
  MAX_BYTES: 2 * 1024 * 1024,
  ACCEPTED_TYPES: ["image/png", "image/jpeg", "image/webp", "image/svg+xml"],
  ACCEPT_ATTR: "image/png,image/jpeg,image/webp,image/svg+xml",
};

export const BADGE_COLORS = [
  { name: "Red", value: "#ef4444" },
  { name: "Orange", value: "#f97316" },
  { name: "Amber", value: "#f59e0b" },
  { name: "Yellow", value: "#eab308" },
  { name: "Lime", value: "#84cc16" },
  { name: "Green", value: "#22c55e" },
  { name: "Emerald", value: "#10b981" },
  { name: "Teal", value: "#14b8a6" },
  { name: "Cyan", value: "#06b6d4" },
  { name: "Sky", value: "#0ea5e9" },
  { name: "Blue", value: "#3b82f6" },
  { name: "Indigo", value: "#6366f1" },
  { name: "Violet", value: "#8b5cf6" },
  { name: "Purple", value: "#a855f7" },
  { name: "Fuchsia", value: "#d946ef" },
  { name: "Pink", value: "#ec4899" },
];
